import styled from "styled-components";

const Bench = styled.div`
  margin-bottom: 3rem;
  background: linear-gradient(#afafaf, #e0e0e0);
  );
`;

export default Bench;
